module.exports = __webpack_public_path__ + "static/media/pl_PL.18edbaaf.svg";